import { useQueryClient, useMutation } from 'react-query';

import { detachCaseDamages, detachDamages } from '@ge/feat-monitor/services';
import { CasesQueryKeys } from '@ge/shared/data-hooks/cases/query-keys';

export const useDetachCaseDamages = (caseId, setShowDetachModal) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation((body) => detachCaseDamages(body), {
    onSuccess: () => {
      queryClient.invalidateQueries(CasesQueryKeys.detail(caseId));
      setShowDetachModal(false);
    },
    onError: (error) => {
      console.log(`there has been an error ${error}`);
    },
  });

  return { mutateAsync, isLoading };
};

export const useDetachDamage = () => {
  const { mutateAsync, isLoading } = useMutation(async(body) => await detachDamages(body));
  return { mutateAsync, isLoading };
};
